export default {"src":"/_next/static/media/broccoli.0dd9be45.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};